import { numberFormatCache } from './constants';
import { getLocale } from './get-locale';
import { FormatOptions } from './price-formatter.type';

/**
 * Formats a plain number (no currency) following the current user's currency
 * preferences so grouping/decimal separators stay consistent with
 * `formatCurrency` (e.g., both `1.234,56 €` and `1.234,56` in locale mode).
 */
export const formatValue = (options: FormatOptions): string => {
  const minFractionDigits = options.minimumFractionDigits ?? 0;
  const maxFractionDigits =
    options.maximumFractionDigits === undefined
      ? Math.max(0, minFractionDigits)
      : Math.max(options.maximumFractionDigits, minFractionDigits);

  const locale = getLocale();
  const key = `decimal-${locale}-${minFractionDigits}-${maxFractionDigits}-${options.shortened ?? false}`;

  let formatter = numberFormatCache.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: minFractionDigits,
      maximumFractionDigits: maxFractionDigits,
      notation: options.shortened ? 'compact' : 'standard',
    });
    numberFormatCache.set(key, formatter);
  }

  return formatter.format(options.number);
};
